export default __webpack_public_path__ + "static/media/veggiebites-wide@3x.6cf91c01.jpg";